import { redirect ,type  LoaderFunctionArgs } from 'react-router-dom';

import { BanService } from '@/services/ban/banService';

export async function action({ params }: LoaderFunctionArgs) {
  const { banId, playerId } = params;
  if (!banId || !playerId) {
    return redirect('404');
  }
  await BanService.deleteBan(banId);

  return redirect(`/players/${playerId}/bans`);
}
